export const META_WARNING_AUTOBCKUPS_FAILED = 'META_WARNING_AUTOBCKUPS_FAILED';

export interface IMapWarningCodeToWarningTitle {
    [name: string]: string
}
export const mapWarningCodeToWarningTitle: IMapWarningCodeToWarningTitle = {
    [META_WARNING_AUTOBCKUPS_FAILED] :  'Automatic backups for this board were turned off'
};
